import { render, staticRenderFns } from "./bind-account.vue?vue&type=template&id=9028cf7a&scoped=true"
import script from "./bind-account.vue?vue&type=script&lang=js"
export * from "./bind-account.vue?vue&type=script&lang=js"
import style0 from "./bind-account.vue?vue&type=style&index=0&id=9028cf7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9028cf7a",
  null
  
)

export default component.exports